import React, { useEffect, useMemo, useState } from 'react'

import { makeGetError } from '../../reduxes/slices/errors/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { ErrorMessage } from './error_message'

type Props = {
  domId: string
}

// Display an error message next to a specific DOM element. Used for frontend errors not originating from the api
// Currently uses the root store, but might need to make another component for the sub store
export const AppErrorMessage = ({ domId }: Props) => {
  const getError = useMemo(makeGetError, [])
  const error = useSelectorDelegateStore((state) => getError(state, domId))
  const [element, setElement] = useState<HTMLElement>()

  useEffect(() => {
    const element = document.getElementById(domId)
    if (element) {
      setElement(element)
    }
  }, [domId])

  if (error) {
    return <ErrorMessage element={element}>{error}</ErrorMessage>
  } else {
    return null
  }
}
